import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import {
  gigyaLogin,
  gigyaJoin,
  gigyaLogOut,
  gigyaInit,
} from '../../actions/auth';
import { loadPageData } from '../../actions/cms';
import HeaderTopBar from './HeaderTopBar';
import { RootState } from '../../reducers';

const Header: React.FC<any> = ({
  fetchSiteData,
  initGigya,
  header,
  removeBg,
  onLogIn,
  onLogOut,
  onJoin,
  isLoggedIn,
  profile,
  isMobile
}) => {
  useEffect(() => {
    fetchSiteData();
    initGigya();
  }, [fetchSiteData, initGigya]);

  const {
    watch_time_block_content,
    login_join_block_content,
    login,
    join,
    station_data_html,
    station_data_notstation
  } = header;
  return (
    <>
      <HeaderTopBar
        onLogIn={onLogIn}
        onLogOut={onLogOut}
        onJoin={onJoin}
        isLoggedIn={isLoggedIn}
        removeBg={removeBg}
        isMobile={isMobile}
        watchHtml={watch_time_block_content}
        joinHtml={login_join_block_content}
        profile={profile}
        loginData={login}
        joinData={join}
        stationHTML={station_data_html}
        station_data_notstation={station_data_notstation}
      />
    </>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  fetchSiteData: () => dispatch(loadPageData()),
  initGigya: () => dispatch(gigyaInit()),
  onLogIn: () => dispatch(gigyaLogin()),
  onLogOut: () => dispatch(gigyaLogOut()),
  onJoin: () => dispatch(gigyaJoin()),
});

const mapStateToProps = (state: RootState) => ({
  header: state.site.header,
  isLoggedIn: state.auth.isLoggedIn,
  profile: state.auth.profile,
});


Header.defaultProps = {
  fetchSiteData: () => {},
  header: {},
};

export { Header };

export default connect(mapStateToProps, mapDispatchToProps)(Header);
